import React, { useEffect, useState } from "react";
import { urls, icons } from "../../../constant";
import { useSelector, useDispatch } from "react-redux";
import {
  setError,
  setLoading,
  setIsSaved,
  setOpenModal,
} from "../../../global-state/redux";
import { getRequest, postRequest } from "../../../network/httpRequest";
import { formatterDate } from "../../../helpers";
import { TedEmpty, TedDropdown, TedButton } from "../../../core-ui";
import { FaSync } from "react-icons/fa";
import "./member-sync.css";

const configHeaderTable = [
  "Date",
  "Nom & Prénom",
  "Sexe",
  "UMVA Card",
  "Province",
  "Commune",
  "Montant",
  "Statut",
  "Action",
];

const ListNewMembers = () => {
  const [dataTable, setDataTable] = useState([]);
  const { isSaved } = useSelector((store) => store.loading);
  const dispatch = useDispatch();

  const getNewMembers = async () => {
    dispatch(setLoading());
    const { err, msg, data, typeErr } = await getRequest(
      `${urls.deposit}/new-members`
    );
    dispatch(setLoading());
    if (err) {
      return dispatch(setError({ err, msg, data, typeErr }));
    }
    setDataTable(data);
  };

  useEffect(() => {
    getNewMembers();
  }, [isSaved]);

  const showEditSyncModal = (member) => {
    console.log('Opening edit sync modal for member:', member);
    dispatch(
      setOpenModal({
        actionName: "editMemberSync",
        data: member,
        actionTitle: `Modifier et synchroniser - ${member.first_name} ${member.last_name}`,
        number: 2,
      })
    );
  };

  const handleSyncMember = async (member) => {
    console.log('Sync button clicked for member:', member);
    showEditSyncModal(member);
  };

  const handleMassSync = async () => {
    const unsyncedMembers = dataTable.filter(m => !m.is_synced);
    if (unsyncedMembers.length === 0) {
      return dispatch(setError({ 
        err: true, 
        msg: "No unsynced members to sync", 
        typeErr: "warning" 
      }));
    }

    dispatch(setLoading());
    const { err, msg, data, typeErr } = await postRequest(
      `${urls.deposit}/new-members/mass-sync`,
      "json",
      { memberIds: unsyncedMembers.map(m => m.id) }
    );
    dispatch(setLoading());
    if (err) {
      return dispatch(setError({ err, msg, data, typeErr }));
    }
    dispatch(setIsSaved());
    getNewMembers();
  };

  const showMemberDetails = (member) => {
    dispatch(
      setOpenModal({
        actionName: "memberDetails",
        data: member,
        actionTitle: `Détails du membre - ${member.first_name} ${member.last_name}`,
        number: 2,
      })
    );
  };

  useEffect(() => {
    getNewMembers();
  }, [isSaved]);

  const configdropDown = (member) => [
    {
      name: "Détails",
      icons: icons.action_details,
      fx: (item) => showMemberDetails(item),
    },
    {
      name: "Synchroniser",
      icons: icons.action_edit,
      fx: (item) => handleSyncMember(item),
      hidden: member.is_synced,
    },
  ];

  const unsyncedCount = dataTable.filter(m => !m.is_synced).length;

  return (
    <div>
      {/* <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'flex-end' }}>
        {unsyncedCount > 0 && (
          <TedButton
            onClick={handleMassSync}
            style={{
              backgroundColor: '#4CAF50',
              color: 'white',
              padding: '10px 20px',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            <FaSync />
            Synchroniser tout ({unsyncedCount})
          </TedButton>
        )}
      </div> */}
      <table className="table-normal">
        <thead>
          <tr>
            {configHeaderTable.map((i, idx) => {
              return <td key={idx}>{i}</td>;
            })}
          </tr>
        </thead>
        <tbody>
          {dataTable &&
            dataTable.map((item) => {
              const {
                id,
                gender,
                first_name,
                last_name,
                umva_cardid,
                province,
                commune,
                createdAt,
                currentbalance,
                is_synced,
              } = item;
              return (
                <tr key={id}>
                  <td>{formatterDate(createdAt)}</td>
                  <td>{`${first_name} ${last_name}`}</td>
                  <td>{gender}</td>
                  <td>{umva_cardid}</td>
                  <td>{province}</td>
                  <td>{commune}</td>
                  <td>{currentbalance} Fbu</td>
                  <td>
                    <span
                      style={{
                        padding: '4px 12px',
                        borderRadius: '12px',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        backgroundColor: is_synced ? '#4CAF50' : '#FF9800',
                        color: 'white',
                      }}
                    >
                      {is_synced ? 'Synchronisé' : 'Non synchronisé'}
                    </span>
                  </td>
                  <td>
                    <div className="actions" style={{ display: 'flex', gap: '10px' }}>
                      {!is_synced && (
                        <button
                          onClick={() => handleSyncMember(item)}
                          style={{
                            backgroundColor: 'var(--td-green)',
                            color: 'white',
                            border: 'none',
                            padding: '6px 12px',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '5px',
                          }}
                        >
                          <FaSync />
                          Sync
                        </button>
                      )}
                      <TedDropdown
                        configdropDown={configdropDown(item).filter(d => !d.hidden)}
                        data={item}
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
      {dataTable.length < 1 && (
        <TedEmpty description={"Aucun membre"} icon={icons.empty} />
      )}
    </div>
  );
};

export default ListNewMembers;
